import {
  Accordion,
  Button,
  Text,
  Title,
  Table,
  Select,
  Group,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { openFileUrl } from "../utils/openReport";

const ReportGICommissionPayment = ({}) => {
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(() =>
    moment().startOf("month").toDate()
  );
  const [toDate, setToDate] = useState(() => moment().endOf("month").toDate());
  const [dateType, setDateType] = useState("paymentDate");
  const [api] = useServerApi();
  const { t } = useTranslation();

  const downloadReport = async () => {
    try {
      setLoading(true);

      // console.log(fromDate, toDate);
      const result = await api.CommissionPayment.getCommissionPaymentReport({
        fromDate,
        toDate,
        dateType,
      });
      // console.log("result", result);
      setLoading(false);
      // console.log(result);
      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      // console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">
        {t(
          "Please select the period of payment date (or bank reconciliation date) of debit notes ."
        )}
      </Text>
      <Group mt="xs">
        <DatePicker
          title="From"
          size="xs"
          allowFreeInput
          placeholder="From"
          value={fromDate}
          onChange={(d) => setFromDate(d)}
        />
        -
        <DatePicker
          title="To"
          size="xs"
          allowFreeInput
          placeholder="To"
          value={toDate}
          onChange={(d) => setToDate(d)}
        />
        <Text size="xs">by</Text>
        <Select
          size="xs"
          defaultValue={"paymentDate"}
          data={[
            { label: "Payment Date", value: "paymentDate" },
            { label: "Match Date", value: "matchedDate" },
            4,
          ]}
          onChange={(type) => setDateType(type)}
        />
      </Group>

      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >
        {t("Download")}
      </Button>
      <></>
    </div>
  );
};

export default ReportGICommissionPayment;
